<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0" cols="12">
			<print-setting :model="this.model" class="pt-0"></print-setting>
		</v-col>
    </v-row>
</template>

<script>
	import PrintSetting from '@/components/common/PrintSetting'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

	export default {
		name:'quotations-print',
        components: {
			PrintSetting
        },			
		mixins: [SettingsOptionsMixin],
		data() {
			return {
				model: 'quotation',
				settings: {
				    'layout': null,
                },
                layouts: [],
                layoutgroups: []
			}
		},

		created() {
			this.infoSettingsPrint()
		}
	}
</script>

<style>

</style>
